import { Main } from '@hulu/margaret-plugins';
import styled from 'styled-components';

export const MainContainer = styled(Main)`
  flex: 1;
  overflow: auto;
  background-color: ${({ theme }): string => theme.colors!.colorFauxBlack};
`;

export const InnerMainContainer = styled.div`
  height: 100%;
  overflow: inherit;
  background-color: ${({ theme }): string => theme.colors!.colorWhite};
`;
